import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import styles from "../../devotee.module.scss";
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { apiRequest, catchErrorMessageHandler } from "../../../../infrastructure/backendService";
import { CMS_BASE_URL } from "../../../../config/apiUrl";
import { EventsDataProps } from "../../../../infrastructure/GlobalContextProvider";
import { EventCardTemplate } from "./EventCardTemplate";
import CONSTANTS from '../../../../config/constants.json';
import ErrorPopup from "../../../common/ErrorPopup";

interface buttonTypeListProps {
  label: string;
  onClickFunction: () => void;
  uniqueLabel: string;
}
interface AllEventsProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Event {
  category: string;
  event_date: string;
  event_description: string;
  event_html_url: string;
  event_image: string;
  event_image_url: string;
  event_title: string;
  event_url: string;
}

const UpcomingEventsInfo: any[] = [];
const SpecialEventsInfo: any[] = [];

export default function AllEvents(props: AllEventsProps): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [upcomingSelectFilterName, setUpcomingSelectFilterName] =
    useState<string>("All_U");
  const [specialselectFilterName, setSpecialselectFilterName] =
    useState<string>("All_S");
  const [specialEventsList, setSpecialEventsList] = useState<
    EventsDataProps[] | any[]
  >([]);
  const [upComingEventsList, setUpComingEventsList] = useState<
    EventsDataProps[] | any[]
  >([]);
  const [visibleUpcomingButtons, setVisibleUpcomingButtons] = useState(5); // Number of visible buttons at a time
  const [selectUpcomingEventType, setSelectedUpcomingEventType] = useState<
    string | null
  >(null);
  const [selectSpecialEventType, setSelectedSpecialEventType] = useState<
    string | null
  >(null);
  const [upComingEventsListD, setUpComingEventsListD] = useState<
    EventsDataProps[] | any[]
  >(UpcomingEventsInfo);
  const [specialEventsListD, setSpecialEventsListD] = useState<
    EventsDataProps[] | any[]
  >(SpecialEventsInfo);
  const [list, setList] = useState([]);

  const ReligiousInfo: any[] = [];
  const HumanServicesInfo: any[] = [];
  const AdministrativeEventsInfo: any[] = [];
  const YouthEducationEventsInfo: any[] = [];

  useEffect(() => {
    getUpComingEvents();
    // console.log('getUpComingEvents called useEffect');
  }, [selectUpcomingEventType]);

  useEffect(() => {
    getSpecialEvents();
    // console.log('getSpecialEvents called useEffect');
  }, [selectSpecialEventType]);

  const getSpecialEvents = (): void => {
    const emptyList = [];
    apiRequest({
      basePath: `${CMS_BASE_URL}`,
      method: "GET",
      endpoint: "/wp-json/wp/v2/specialevents?per_page=100",
      // params: {
      //    type: selectSpecialEventType
      // }
    })
      .then((res) => {
        const acfObjects = res.data.map((event: any) => event.acf || {});
        setSpecialEventsList(acfObjects);
      })
      .catch((err) => {
        
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: CONSTANTS.TOAST_POPUP_DURATION,
        });
      });
  };

  const getUpComingEvents = (): void => {
    apiRequest({
      basePath: `${CMS_BASE_URL}`,
      method: "GET",
      endpoint: "/wp-json/wp/v2/upcomingevents?per_page=100",
    })
      .then((res) => {
        // Check if a category is provided before filtering events
        const filteredEvents = selectUpcomingEventType
          ? res.data.filter(
            (event: any) =>
              event.acf && event.acf.category === selectUpcomingEventType
          )
          : res.data;

        // Extract acf objects from the filtered events
        const acfObjects = filteredEvents.map((event: any) => event.acf || {});

        // Set up the upcoming events list
        setUpComingEventsList(acfObjects);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: CONSTANTS.TOAST_POPUP_DURATION,
        });
      });
  };

  const buttonOnClick = (
    parameter: string | null,
    uniqueLabel: string,
    setselectLabelName: React.Dispatch<React.SetStateAction<string>>,
    setSelectTypeName: React.Dispatch<React.SetStateAction<string | null>>
  ): void => {
    setselectLabelName(uniqueLabel);
    setSelectTypeName(parameter);
    const getEventList = (): any[] => {
      switch (uniqueLabel) {
        case "All_U":
          return UpcomingEventsInfo;
        case "Religious_U":
          return ReligiousInfo;
        case "Human_Services_U":
          return HumanServicesInfo;
        case "Administrative_U":
          return AdministrativeEventsInfo;
        case "Young_Adults_U":
          return YouthEducationEventsInfo;
        case "Youth_Education_U":
          return YouthEducationEventsInfo;
        default:
          return UpcomingEventsInfo;
      }
    };
    setUpComingEventsListD(getEventList());
  };

  const UpcomingEventsTypeFilters: buttonTypeListProps[] = [
    {
      label: "All",
      onClickFunction: () => {
        buttonOnClick(
          null,
          "All_U",
          setUpcomingSelectFilterName,
          setSelectedUpcomingEventType
        );
      },
      uniqueLabel: "All_U",
    },
    {
      label: "Religious",
      onClickFunction: () => {
        buttonOnClick(
          "rel",
          "Religious_U",
          setUpcomingSelectFilterName,
          setSelectedUpcomingEventType
        );
      },
      uniqueLabel: "Religious_U",
    },
    {
      label: "Human Services",
      onClickFunction: () => {
        buttonOnClick(
          "hs",
          "Human_Services_U",
          setUpcomingSelectFilterName,
          setSelectedUpcomingEventType
        );
      },
      uniqueLabel: "Human_Services_U",
    },
    {
      label: "Young Adults",
      onClickFunction: () => {
        buttonOnClick(
          "ya",
          "Young_Adults_U",
          setUpcomingSelectFilterName,
          setSelectedUpcomingEventType
        );
      },
      uniqueLabel: "Young_Adults_U",
    },
    {
      label: "Youth and Education",
      onClickFunction: () => {
        buttonOnClick(
          "ye",
          "Youth_Education_U",
          setUpcomingSelectFilterName,
          setSelectedUpcomingEventType
        );
      },
      uniqueLabel: "Youth_Education_U",
    },
    {
      label: "Administrative",
      onClickFunction: () => {
        buttonOnClick(
          "ad",
          "Administrative_U",
          setUpcomingSelectFilterName,
          setSelectedUpcomingEventType
        );
      },
      uniqueLabel: "Administrative_U",
    },
  ];

  const SpecialEventsTypeFilters: buttonTypeListProps[] = [
    {
      label: "All",
      onClickFunction: () => {
        buttonOnClick(
          "All",
          "All_S",
          setSpecialselectFilterName,
          setSelectedSpecialEventType
        );
      },
      uniqueLabel: "All_S",
    },
    {
      label: "Religious",
      onClickFunction: () => {
        buttonOnClick(
          "rel",
          "Religious_S",
          setSpecialselectFilterName,
          setSelectedSpecialEventType
        );
      },
      uniqueLabel: "Religious_S",
    },
  ];

  const FilterButtons = (
    filterList: buttonTypeListProps[],
    selectLabelName: string,
    showArrows: boolean
  ) => {
  const [upcomingButtonsOffset, setUpcomingButtonsOffset] = useState(0);

    const handleNextUpcomingButtons = (): void => {
      const totalButtons = UpcomingEventsTypeFilters.length;
      const remainingButtons =
        totalButtons - (upcomingButtonsOffset + visibleUpcomingButtons);
      const nextOffset = Math.min(
        upcomingButtonsOffset + visibleUpcomingButtons,
        totalButtons - 1
      );
      setVisibleUpcomingButtons(
        remainingButtons > 0 ? visibleUpcomingButtons : remainingButtons
      );
      setUpcomingButtonsOffset(nextOffset);
    };

    const handlePrevUpcomingButtons = (): void => {
      const nextOffset = Math.max(
        upcomingButtonsOffset - visibleUpcomingButtons,
        0
      );
      setVisibleUpcomingButtons(visibleUpcomingButtons);
      setUpcomingButtonsOffset(nextOffset);
    };
    
  const isPrevIconDisabled = upcomingButtonsOffset === 0;
  const isNextIconDisabled =
    upcomingButtonsOffset + visibleUpcomingButtons >=
    UpcomingEventsTypeFilters.length;
    return (
      <div className={styles.ButtonTypesContainer}>
        {showArrows ? (
          <ChevronLeftIcon
            className={`${styles.icon} ${isPrevIconDisabled ? styles.disable : styles.active
              }`}
            onClick={() => !isPrevIconDisabled && handlePrevUpcomingButtons()}
          />
        ) : (
          ""
        )}

        {filterList
          .slice(
            upcomingButtonsOffset,
            upcomingButtonsOffset + visibleUpcomingButtons
          )
          .map((item: buttonTypeListProps, index: number) => (
            <button
              key={index}
              onClick={item.onClickFunction}
              className={
                selectLabelName === item.uniqueLabel
                  ? `${styles.activeButton}`
                  : `${styles.filterButtons}`
              }
            >
              {item.label}
            </button>
          ))}
        {showArrows ? (
          <ChevronRightIcon
            sx={{ marginLeft: "auto" }}
            className={`${styles.icon} ${isNextIconDisabled ? styles.disable : styles.active
              }`}
            onClick={() => !isNextIconDisabled && handleNextUpcomingButtons()}
          />
        ) : (
          ""
        )}
      </div>
    );
  };

  const eventsTemplate = (
    eventTypeName: string,
    eventsList: any,
    filterTypeList: buttonTypeListProps[],
    selectLabelName: string,
    showArrows: boolean,
    eventType: string,
  ): React.ReactElement => {
    const useDefaultEvents = eventsList.length === 0;
    
    eventsList = eventsList.sort((a: Event, b: Event) => {
      return parseInt(a.event_date) - parseInt(b.event_date);
    });
    return (
      <div>
        
        <div
          className={
            eventTypeName === CONSTANTS.SPECIAL_EVENTS
              ? `${styles.EventsTotalSpecialLayout}`
              : `${styles.EventsTotalUpComingLayout}`
          }
        >
          <h2 style={{ fontSize: '22px', marginTop: "-10px" }}>{eventTypeName}</h2>
          {FilterButtons(filterTypeList, selectLabelName, showArrows)}
          <div
            className={
              eventTypeName === CONSTANTS.SPECIAL_EVENTS
                ? `${styles.allEventsContainer}`
                : `${styles.allUpcomingEventsContainer}`
            }

            style={useDefaultEvents ? { overflow: "hidden" } : {}}
          >
            <div className={styles.allEventsLayout}>
              {useDefaultEvents ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontWeight: "700",
                    alignItems: "center",
                    height: "600px",
                  }}
                >
                  <img
                    src="/images/EmptyBookPooja.svg"
                    alt="no data"
                    className={styles.noEvents}
                  />
                  <p>No Events Found</p>
                </div>
              ) : (
                eventsList.map((info: any) => (
                  <div key={info.name} className={styles.cardInfo}>
                    <EventCardTemplate
                      eventCardProps={{
                        name: info.event_title || info.event_title,
                        FromToDate:
                          info?.event_description || info?.event_description,
                        imgUrl: info.event_image_url || info.event_image_url,
                        eventUrl: info.html_page || info.event_url,
                        isHtmlPage : Boolean(info.html_page),
                        event_id: info.event_id,
                        eventType: eventType
                      }}
                      setIsOpen={props.setIsOpen}
                    />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.AllEventsLayout}>
      {eventsTemplate(
        CONSTANTS.SPECIAL_EVENTS,
        specialEventsList,
        SpecialEventsTypeFilters,
        specialselectFilterName,
        false,
        "specialEvents"
      )}
      {eventsTemplate(
        CONSTANTS.UPCOMING_EVENTS,
        upComingEventsList,
        UpcomingEventsTypeFilters,
        upcomingSelectFilterName,
        true,
        "upComingEvents"
      )}
    </div>
  );
}
